var exports = {
  "f": "xa15a2ab7--6bc278--seo-block",
  "y": "xa15a2ab7--6bc278--links",
};

module.exports = exports;
